import MultiSelectFilter from './MultiSelectFilter'

import { IncludeExcludeFilterWrapper } from '../styles'

interface IncludeExcludeFiltersProps {
  excludeLabel: StringOrMessage
  includeLabel: StringOrMessage
  onChange: (filter: 'exclude' | 'include', selectedValues: CommonIdAndNameType[]) => void
  options: CommonIdAndNameType[]
  testId?: string
  values: { exclude: CommonIdAndNameType[]; include: CommonIdAndNameType[] }
}

export default function IncludeExcludeFilters({
  excludeLabel,
  includeLabel,
  onChange,
  options,
  testId,
  values: { exclude, include },
}: IncludeExcludeFiltersProps) {
  function handleIncludeChange(selectedValueKeys: Array<CommonIdAndNameType['id']>) {
    onChange(
      'include',
      options.filter(({ id }) => selectedValueKeys.includes(id))
    )
  }

  function handleExcludeChange(selectedValueKeys: Array<CommonIdAndNameType['id']>) {
    onChange(
      'exclude',
      options.filter(({ id }) => selectedValueKeys.includes(id))
    )
  }

  return (
    <IncludeExcludeFilterWrapper data-testid={testId}>
      <MultiSelectFilter
        label={includeLabel}
        onChange={handleIncludeChange}
        options={options}
        value={include.map(({ id }) => id)}
      />
      <MultiSelectFilter
        label={excludeLabel}
        onChange={handleExcludeChange}
        options={options}
        value={exclude.map(({ id }) => id)}
      />
    </IncludeExcludeFilterWrapper>
  )
}
